import { TEMPLATE_FILES, TemplateType } from '@/features/interwill';
import { useModalsStore } from '@/widgets/modals/modals.store';

import { Section, SectionType } from '../types';

export const useContent = () => {
  const { openModal } = useModalsStore();

  const sections: Section[] = [
    {
      key: 'intro',
      type: SectionType.CONTENT,
    },
    {
      key: 'mandatoryParticipants',
      type: SectionType.CONTENT,
    },
    {
      key: 'optionalParticipants',
      type: SectionType.CONTENT,
    },
    {
      key: 'restrictions',
      type: SectionType.CONTENT,
      buttonAction: () => {
        openModal({
          type: 'FilePreviewModal',
          mode: 'fileInfo',
          fileInfo: TEMPLATE_FILES[TemplateType.DEMO_WILL],
        });
      },
    },
    {
      key: 'participantGoodwill',
      type: SectionType.CONTENT,
    },
    {
      key: 'pepStatus',
      type: SectionType.CONTENT,
    },
    {
      key: 'whoCannotBeAWitness',
      type: SectionType.CONTENT,
    },
    {
      key: 'whoCannotBeAnExecutor',
      type: SectionType.CONTENT,
    },
    {
      key: 'obligationsandRestrictions',
      type: SectionType.CONTENT,
    },
    {
      key: 'generalInformationforParticipants',
      type: SectionType.LIST,
      itemsCount: 7,
    },
    {
      key: 'assetDataSources',
      type: SectionType.CONTENT,
    },
    {
      key: 'willLanguageandTranslation',
      type: SectionType.CONTENT,
    },
    {
      key: 'dataSecurity',
      type: SectionType.CONTENT,
      link: 'https://owner.one/security/',
    },
    {
      key: 'accesstoWillData',
      type: SectionType.CONTENT,
      link: 'https://owner.one/international-will/',
    },
    {
      key: 'estateCaseContents',
      type: SectionType.LIST,
      itemsCount: 8,
      isUnordered: true,
    },
    {
      key: 'testatorSteps',
      type: SectionType.LIST,
      itemsCount: 18,
    },
    {
      key: 'beneficiarySteps',
      type: SectionType.LIST,
      itemsCount: 7,
      hasNote: true,
    },
    {
      key: 'witnessSteps',
      type: SectionType.LIST,
      itemsCount: 7,
      hasNote: true,
    },
    {
      key: 'executorSteps',
      type: SectionType.LIST,
      itemsCount: 9,
    },
    {
      key: 'additionalAssetData',
      type: SectionType.CONTENT,
    },
    {
      key: 'willBook',
      type: SectionType.CONTENT,
    },
    {
      key: 'triggersAlgorithms',
      type: SectionType.CONTENT,
    },
    {
      key: 'updatingYourWill',
      type: SectionType.CONTENT,
    },
  ];

  return sections;
};
